import { type RefObject, useEffect, useRef } from "react";

function useClickOutside<T extends HTMLElement>(handler: (event: MouseEvent) => void): RefObject<T | null> {
    const ref = useRef<T>(null);
    useEffect(() => {
        const handleClick = (event: any) => {
            if (ref.current && !ref.current.contains(event.target)) {
                handler(event);
            }
        };
        document.addEventListener("click", handleClick, true);
        return () => {
            document.removeEventListener("click", handleClick, true);
        };
    }, [handler]);

    return ref;
}

export default useClickOutside;
